import Model from './BaseModel'
import CommissionItems from './CommissionItems'
import CommissionPeriod from './CommissionPeriod'
import CommissionActivations from './CommissionActivations'
import Tax from './Tax'
import Reseller from './Reseller'
import i18n from '@/plugins/i18n'
import _ from 'lodash'
import moment from 'moment'

export default class Commission extends Model {
    resourceName() {
        return 'commissions'
    }

    fields() {
        return [
            'month',
            'year',
            'paid_at',
            'category_id',
            'baseValue',
            'totalValue',
            'taxedValue',
            'paid',
            'approved',
            'approved_at',
            'confirmed',
            'confirmed_at',
            'reviewed',
            'reviewed_at',
            'reproved',
            'reproved_details',
            'payment_voucher',
            'invoice',
            'category',
            'is_current_month',
        ]
    }

    relationships() {
        return {
            reseller: new Reseller(),
            items: new CommissionItems(),
            commissionPeriods: new CommissionPeriod(),
            commissionActivations: new CommissionActivations(),
            tax: new Tax(),
        }
    }

    dates() {
        return {
            paid_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            formattedBaseValue(commission) {
                return i18n.n(commission.baseValue, 'currency')
            },

            formattedTotalValue(commission) {
                return i18n.n(commission.totalValue, 'currency')
            },

            formattedPaidAt(commission) {
                return commission.paid_at.isValid()
                    ? i18n.d(commission.paid_at, 'datetime')
                    : null
            },

            itemsActivation(commission) {
                return _.filter(commission.items, each => {
                    return !!each.activation_id
                })
            },

            itemsCommission(commission) {
                return _.filter(commission.items, each => {
                    return !each.activation_id
                })
            },

            totalValueCommission(commission) {
                let items = _.filter(commission.items, each => {
                    return !each.activation_id
                })
                return _.sumBy(items, o => o.value)
            },

            totalValueActivation(commission) {
                let items = _.filter(commission.items, each => {
                    return !!each.activation_id
                })

                return _.sumBy(items, o => o.value)
            },

            reference(commission) {
                moment.locale('pt-br')

                let parsed = moment()
                    .day(1)
                    .month(commission.month - 1)
                    .year(commission.year)
                    .format('MMMM/YYYY')

                return parsed
            },

            formattedTax(commission) {
                if (commission.tax.value) {
                    return commission.tax.formattedValue
                }

                return '0%'
            },

            formattedTaxedValue(commission) {
                return i18n.n(commission.taxedValue, 'currency')
            },

            showForm(commission) {
                return (
                    !commission.approved ||
                    (commission.confirmed && !commission.paid)
                )
            },

            showPaidConfirmation(commission) {
                return (
                    commission.approved &&
                    commission.confirmed &&
                    commission.reviewed &&
                    !commission.paid
                )
            },
        }
    }

    get searchable() {
        return ['search']
    }
}
